import { Form, Modal, TextInput } from '@carbon/react';
import { create, eager, enforce, test } from 'vest';

import useForm from 'utils/hooks/useForm';
import useUpdateEffect from 'utils/hooks/useUpdateEffect';

const suite = create((data = {}) => {
  eager();

  test('name', 'Project Name is required', () => {
    enforce(data.name).isNotEmpty();
  });
});

const mapDefaultName = (name) => `${name}-Copy`;

const SaveProjectAsModal = ({ open, initialProjectName, onCancel, onSave }) => {
  const { handleSubmit, reset, register } = useForm({
    suite,
    defaultValues: {
      name: mapDefaultName(initialProjectName)
    }
  });

  useUpdateEffect(() => {
    if (open) {
      reset({
        name: mapDefaultName(initialProjectName)
      });
    }
  }, [open]);

  const handleFormSubmit = (values) => onSave(values.name);

  return (
    <Modal
      open={open}
      size="xs"
      modalHeading="Save As"
      primaryButtonText="Save"
      secondaryButtonText="Cancel"
      onRequestClose={onCancel}
      onRequestSubmit={handleSubmit(handleFormSubmit)}
      onSecondarySubmit={onCancel}
    >
      <Form onSubmit={handleSubmit(handleFormSubmit)}>
        <p>Save project as</p>
        <br />
        <TextInput
          id="project-name"
          labelText="Project Name"
          hideLabel
          placeholder="Project Name"
          {...register('name')}
        />
      </Form>
    </Modal>
  );
};

export default SaveProjectAsModal;
